<template>
  <div>
    <div class="card-header">
      Client paid invoice
    </div>
    <div class="card-body">
      <p class="invoice-state-description">
        Wait for the client to pay the invoice. If you have received the payment, enter the amount paid excluding VAT.
        Do not subtract the fee as this will be done in the wallet-service.
      </p>
      <div class="form-group">
        <label for="amount">Amount Paid</label>
        <div class="input-group">
          <select class="form-control text-readable" id="currency" v-model="currency" aria-label="Currency" style="max-width: 5.5rem; color: #989898 !important;">
            <option value="SEK">SEK</option>
            <option value="EUR">EUR</option>
            <option value="USD">USD</option>
          </select>
          <input id="amount" type="number" class="form-control" v-model="amount"
                 :placeholder="`Amount paid (Excluding VAT) in ${currency}`"/>
        </div>
      </div>
      <div class="form-group">
        <label for="comment">Comment</label>
        <textarea id="comment" class="form-control mt-0" placeholder="Additional comment to the talent for this payment"
                  v-model="comment"></textarea>
      </div>
      <div class="row">
        <div class="col mb-3">
          <div class="d-flex justify-content-start align-items-start flex-wrap flex-lg-nowrap" style="gap: 15px;">
            <div v-if="invoice.quick_pay === 2">
              <div>Quick Pay Fee (%)</div>
              <input type="text" id="charge_fee" readonly disabled :value="quickPayFee" class="form-control">
            </div>
            <auto-input label="Charge Fee (%)" v-model="fee"
                        field_name="charge_fee"
                        :route="getUpdateRoute"></auto-input>
          </div>
        </div>
        <div class="col" v-if="!isNaN(amount)" style="max-width: 21rem;">
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted">Amount Paid</span>
            <h3 class="text-right text-muted mb-0 pb-0">
              {{ amount | formatCurrency(this.currency) }}
            </h3>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div>Amount After Charge Fees</div>
              <div class="text-info d-flex justify-content-between">
                <span>Total Fee:</span>
                <span>{{totalFee}} %</span>
              </div>
            </div>
            <h1 class="text-right mb-0">
              {{ afterFees | formatCurrency(this.currency) }}
            </h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <confirm-toggle v-model="accepted"
                          label="I have received the payment and entered the amount received excluding VAT"></confirm-toggle>
        </div>
        <div class="col-md-6">
          <button type="submit" class="btn btn-primary btn-block" @click.prevent="accept"
                  :disabled="validateInputs">Mark invoice as paid by client
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultState from './DefaultState';

export default {
  name: 'Sent',
  extends: DefaultState,
  data() {
    return {
      comment: undefined,
      amount: undefined,
      accepted: false,
      currency: this.invoice.currency || 'SEK',
      fee: parseFloat(this.invoice.charge_fee) || 0.0,
      quickPayFee: parseFloat(this.invoice.quick_pay_fee) || 0.0,
    };
  },
  computed: {
    validateInputs() {
      return !this.accepted || !this.amount;
    },
    getUpdateRoute() {
      return `/invoices/handler/${this.invoice.id}/fee`;
    },
    totalFee() {
      let quickPayFee = this.invoice.quick_pay >= 2 ? this.quickPayFee : 0;
      return this.fee + quickPayFee;
    },
    afterFees() {
      if (isNaN(this.fee)) {
        return '-';
      }
      return (this.amount * (1 - (this.totalFee / 100)));
    },
  },
  methods: {
    accept() {
      if (!this.amount) {
        this.$toasted.error('No amount set');
        return;
      }

      if (isNaN(this.fee)) {
        this.$toasted.error('No fee set');
        return;
      }

      const object = {
        transition: this.getTransition('PaymentReceived'),
        comment: this.comment,
        amount: this.amount,
        currency: this.currency,
      };
      this.action(object);
    },
  },
};
</script>

<style scoped>
.form-check.invoice {
  margin-top: 0px;
}

textarea {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 200px;
}
</style>
